import GlobalProp from '../global-props'

const youtubeHelper = (props, property, classList) => {
  const { autoPlay, videoId, loop } = props
  const runtimeAutoplay = GlobalProp.isRuntime ? autoPlay : 0
  const isMuted = autoPlay
  // Autoplay is only enabled for muted videos ( https://developers.google.com/web/updates/2017/09/autoplay-policy-changes )

  const src = loop ? `${videoId}?playlist=${videoId}` : `${videoId}?`
  return `
    <div
      data-type="video"
      data-property="${property}"
      class="${classList}"
    >
      <iframe
        src="//www.youtube.com/embed/${src}&amp;rel=0&amp;showinfo=0&amp;autoplay=${runtimeAutoplay}&amp;mute=${isMuted}&amp;loop=${loop}"
        frameborder="0"
        ${isMuted && 'muted="true"'}
        allow="autoplay; encrypted-media"
        allowfullscreen></iframe>
    </div>`
}

export default youtubeHelper
